module.exports = __webpack_public_path__ + "img/order-no-data.f7788299.png";